import React from 'react';
import { Button, ButtonProps } from '@99designs/emu';
import { IconDownload1 } from '@99designs/icons';
import { usePrintTemplate } from './usePrintTemplate';

const defaultAppearance = {
    selected: {
        backgroundColor: 'transparent',
        backgroundColorActive: 'transparent',
        backgroundColorHover: 'transparent',
        borderColor: 'grey800',
        borderColorActive: 'grey900',
        borderColorHover: 'grey800',
        textColor: 'grey800',
        textColorActive: 'grey900',
        textColorHover: 'grey800',
    },
    normal: {
        backgroundColor: 'transparent',
        backgroundColorActive: 'transparent',
        backgroundColorHover: 'transparent',
        borderColor: 'pacific',
        borderColorActive: 'pacificDark',
        borderColorHover: 'pacificLight',
        textColor: 'pacific',
        textColorActive: 'pacificDark',
        textColorHover: 'pacificLight',
    },
    disabled: {
        backgroundColor: 'transparent',
        backgroundColorActive: 'transparent',
        backgroundColorHover: 'transparent',
        borderColor: 'grey200',
        borderColorActive: 'grey200',
        borderColorHover: 'grey200',
        textColor: 'grey400',
        textColorActive: 'grey400',
        textColorHover: 'grey400',
    },
};

export type PrintTemplateDownloadButtonProps = {
    externalPrintId: string;
    appearance?: ButtonProps['appearance'];
    location?: string;
    projectId?: string;
    category: {
        key: string;
        title: string;
    };
};

export function PrintTemplateDownloadButton({
    projectId,
    location,
    category,
    externalPrintId,
    appearance,
}: PrintTemplateDownloadButtonProps) {
    const externalPrintIdToNumber = externalPrintId ? parseInt(externalPrintId, 10) : 0;
    const {
        downloadTemplateLinkRef,
        templateBlobData,
        filename,
        loading,
        error,
        handlePrintTemplateOnClick,
    } = usePrintTemplate(externalPrintIdToNumber, category.key, projectId, location);

    return (
        <Button
            ref={downloadTemplateLinkRef}
            href={templateBlobData}
            download={filename}
            appearance={appearance || defaultAppearance}
            type="button"
            icon={IconDownload1}
            onClick={(e) => {
                if (!templateBlobData) {
                    handlePrintTemplateOnClick(e);
                }
            }}
            loading={loading}
            disabled={!!error}
        >
            {__('Print template')}
        </Button>
    );
}
